import { useEffect, useRef, useState } from 'react';
import { API_SERVER } from '../../EnvConfig/env_config';
import { ApiCall, FindTranslatedKey, convertToNumber, handleDateChange } from '../CommonComponents/CustomHooks';
import { handleDownloadExcel } from '../CommonComponents/ExportData';
import { DateBox, FormButton, InputBox, CheckBoxInput, base64ToBlob } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { useDispatch } from 'react-redux';
import { NotificationSound } from '../CommonComponents/CommonNotification';

const ManifestReport = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch([]);
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const selectedDate = new Date();
    selectedDate.setDate(selectedDate.getDate() - 14);
    const selectedDate2 = new Date();
    selectedDate2.setDate(selectedDate2.getDate());
    const dateArr = selectedDate.toDateString().split(" ");
    const formattedDate = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`;
    const dateArr2 = selectedDate2.toDateString().split(" ");
    const formattedDate1 = `${dateArr2[2]}-${dateArr2[1]}-${dateArr2[3]}`;
    const [formData, setFormData] = useState({
        manifestDateFrom: formattedDate,
        manifestDateTo: formattedDate1,
        manifestNo: '',
        cCode: '',
        awbNo: '',
        manifestPending: false,
        manifestReportDetail: false,

    });
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };
    const getManifestReportData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...formData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setIsLoading(true)
        let data = await ApiCall('/api/Report/ManifestReport', GetData)
        setTableData(data)
        setIsLoading(false)
        if (data.Status === 'ERROR' || data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handlePrint = async (value) => {
        await dispatch(setSubLoading(true))
        let imgresult = await ApiCall('/api/Report/ManifestPrint', { ManifestNo: value });
        await dispatch(setSubLoading(false))
        let result = imgresult;
        if (result.status === 'ERROR' || result.status === 'EXPIRED') {
            await NotificationSound(result.status, result.message, '', '', '');
            await dispatch(setSubLoading(false))
        }
        const blob = base64ToBlob(result.documentPdfBase64?.split(',')[1], 'application/pdf');
        const url = URL.createObjectURL(blob);
        const PDFWindow = window.open("");
        PDFWindow.document.write("<iframe width='100%' height='100%' src='" + url + "'></iframe>");
        
    }

    const handlePrint1 = async (value) => {
        await dispatch(setSubLoading(true))
        let imgresult = await ApiCall('/api/Report/ManifestPrintNew', { ManifestNo: value });
        await dispatch(setSubLoading(false))
        let result = imgresult;
        if (result.status === 'ERROR' || result.status === 'EXPIRED') {
            await NotificationSound(result.status, result.message, '', '', '');
            await dispatch(setSubLoading(false))
        }
        const blob = base64ToBlob(result.documentPdfBase64?.split(',')[1], 'application/pdf');
        const url = URL.createObjectURL(blob);
        const PDFWindow = window.open("");
        PDFWindow.document.write("<iframe width='100%' height='100%' src='" + url + "'></iframe>");

    }

    const handleClear = () => {
        setFormData({
            manifestDateFrom: formattedDate,
            manifestDateTo: formattedDate1,
            manifestNo:'',
            cCode: '',
            awbNo: '',
            manifestPending: false,
            manifestReportDetail: false,
        });
        getManifestReportData()
        inputrefs.current['txtFromDate'].focus()
    }

    const handleChange1 = (event, value) => {
        getManifestReportData(value);
    };
    useEffect(() => {
        getManifestReportData()
    }, [sortConfig])

    useEffect(() => {
        document.title = 'Manifest Report'
        inputrefs.current['txtFromDate'].focus()
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {FindTranslatedKey('Manifest Report')} </h6>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <DateBox
                                inputrefs={inputrefs}
                                label="Booking Date From"
                                placeholder="Booking Date From"
                                id='txtFromDate'
                              //  value={formData.manifestDateFrom ? formData.manifestDateFrom : ''}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtToDate'].focus()
                                    };
                                }}
                                required={false}
                                selected={formData.manifestDateFrom === '' ? '' : new Date(formData.manifestDateFrom)}
                                onChange={(e) => handleDateChange(e, setFormData, formData, 'manifestDateFrom')}
                            />
                            <DateBox
                                inputrefs={inputrefs}
                                label="Booking Date To"
                                placeholder="Booking Date To"
                                id='txtToDate'
                               // value={formData.manifestDateTo ? formData.manifestDateTo : ''}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtManifestNo'].focus()
                                    };
                                }}
                                required={false}
                                selected={formData.manifestDateTo === '' ? '' : new Date(formData.manifestDateTo)}
                                onChange={(e) => handleDateChange(e, setFormData, formData, 'manifestDateTo')}
                            />

                            <InputBox
                                id="txtManifestNo"
                                PlaceHolderText="Manifest No."
                                autoComplete="off"
                                maxLength='30'
                                required={false}
                                label='Manifest No.'
                                value={formData.manifestNo}
                                onChange={(e) => setFormData({ ...formData, manifestNo: e.target.value})}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtAWBBill'].focus()
                                    }
                                }}
                            />

                            <InputBox
                                id="txtAWBBill"
                                PlaceHolderText="AWB No."
                                autoComplete="off"
                                maxLength='25'
                                required={false}
                                label='AWB No.'
                                value={formData.awbNo}
                              
                                onChange={(e) => {
                                    setFormData({ ...formData, awbNo: e.target.value })
                                }}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtmanifestPending'].focus()
                                    }
                                }}
                            />
                            <div className='col-md-4 col-lg-4 col-sm-12 row  cntrl-width'>
                                <CheckBoxInput
                                    label='Un-bagging'
                                    inputrefs={inputrefs}
                                    id='txtmanifestPending'
                                    divclassname='col-md-7'
                                    checked={formData.manifestPending}
                                    onChange={(e) => setFormData({ ...formData, manifestPending: e.target.checked })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtDetail'].focus() };
                                    }}
                                />
                                <CheckBoxInput
                                    label='Detail'
                                    inputrefs={inputrefs}
                                    divclassname='col-md-5'
                                    id='txtDetail'
                                    checked={formData.manifestReportDetail}
                                    onChange={(e) => setFormData({ ...formData, manifestReportDetail: e.target.checked })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['btnSub'].focus() };
                                    }}
                                />
                            </div>
                          
                        </div>
                    </div>
                    <div className='card-body'>
                        <FormButton
                            id={'btnSub'}
                            Search={true}
                            save={false}
                            inputrefs={inputrefs}
                            handleSubmit={getManifestReportData}
                            handleExport={() => handleDownloadExcel(`/api/Report/ManifestReport`, formData, 'Manifest Report')}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>
            <Table
                PageName={'ManifestReport'}
                loading={isLoading}
                Filter={false}
                tableData={tableData}
                handlePrint={handlePrint}
                handlePrint1={handlePrint1}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default ManifestReport;